import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import Toaster from "@meforma/vue-toaster";
import BootstrapVue3 from "bootstrap-vue-3";
import VueSplide from "@splidejs/vue-splide";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";

import currencies from "./helpers/currencies";
import { captureFacebookAttribution } from "./helpers/facebookAttribution";
import "./assets/custom.scss";
import TextCarrousel from './components/Layouts/TextCarrousel';

const FORCED_COUNTRY = "US"; // Temporal: dejar null para volver a autodetección.

async function initializeApp() {
  const app = createApp(App);

  app.component('TextCarrousel', TextCarrousel);

  app.use(router)
    .use(store)
    .use(Toaster)
    .use(VueAxios, axios);
  app.use(VueSplide);
  app.use(BootstrapVue3);

  captureFacebookAttribution(router.currentRoute.value.query);
  if (typeof window !== "undefined") {
    captureFacebookAttribution(window.location.search);
  }

  router.afterEach((to) => {
    captureFacebookAttribution(to.query);
  });

  // Función para cargar datos y establecer el país global
async function cargarDatos() {
  const cacheKey = 'currencyInfo';
  const cacheLifetime = 30 * 60 * 1000; // 30 minutos en milisegundos
  const now = Date.now();
//  localStorage.removeItem(cacheKey);
  let currency = 'US'; // fallback en caso de error o datos inválidos

  if (FORCED_COUNTRY) {
    localStorage.setItem(cacheKey, JSON.stringify({
      currency: FORCED_COUNTRY,
      expiresAt: now + cacheLifetime
    }));

    app.config.globalProperties.$country = FORCED_COUNTRY;
    app.config.globalProperties.$currencie = currencies[FORCED_COUNTRY];
    return;
  }

  try {
    const cached = localStorage.getItem(cacheKey);

    if (cached) {
      const parsed = JSON.parse(cached);

      if (parsed.expiresAt > now && parsed.currency) {
        currency = parsed.currency;
        // console.log('[cache] Detected currency:', currency);
      } else {
        // Expiró o inválido: hacer fetch
        currency = await fetchAndCacheCurrency(cacheKey, now, cacheLifetime);
      }
    } else {
      // No hay nada en cache: hacer fetch
      currency = await fetchAndCacheCurrency(cacheKey, now, cacheLifetime);
    }
  } catch (error) {
    console.error('Currency detection failed:', error);
    currency = 'US';
  }

  app.config.globalProperties.$country = currency;
  app.config.globalProperties.$currencie = currencies[currency];
}

async function fetchAndCacheCurrency(cacheKey, now, cacheLifetime) {
  try {
    const response = await fetch('https://a2iqtest-main-qpplgk.laravel.cloud/detect-currency');

    if (!response.ok) throw new Error(`Request failed: ${response.status}`);

    const data = await response.json();
    const allowedCurrencies = ["US", "MX"];
    const currencyCode = (data.currency || 'US').toUpperCase();
    const currency = allowedCurrencies.includes(currencyCode) ? currencyCode : 'US';

    // Guardar en localStorage con expiración
    localStorage.setItem(cacheKey, JSON.stringify({
      currency: currency,
      expiresAt: now + cacheLifetime
    }));

    // console.log('[api] Detected currency:', currency);
    return currency;

  } catch (error) {
    console.error('[api fallback] Currency fetch failed:', error);
    return 'US';
  }
}


  // Esperar que la función cargarDatos termine
  await cargarDatos();
  
  // Montar la aplicación después de cargar los datos
  app.mount("#app");
}

// Ejecutar la inicialización de la app
initializeApp();
